/**
 * Represents a chat instance
 */
class ChatModel {
  /**
   * @param {string} id - Unique identifier for the chat
   * @param {string} chatName - Name of the chat
   * @param {string} avatarName - Name of the avatar
   * @param {string} avatarId - ID of the avatar
   * @param {Date} created - Creation date of the chat
   */
  constructor({id, chatName, avatarName, avatarId, created}) {
    this.id = id;
    this.chatName = chatName;
    this.avatarName = avatarName;
    this.avatarId = avatarId;
    this.created = created;
  }

  /**
   * Converts the model to a JSON object
   * @returns {Object}
   */
  toJSON() {
    return {
      id: this.id,
      chatName: this.chatName,
      avatarName: this.avatarName,
      avatarId: this.avatarId,
      created: this.created.toISOString()
    };
  }
}

export default ChatModel;
